export default "__VITE_ASSET__BDynjSy9__"